
import React, { useCallback, useEffect, useState } from 'react';

import IOption from '../../interfaces/IOption';
import ColourBubble from '../ColourBubble';

import styles from './styles.module.scss'

interface IColourBubbles {
  color?: IOption | null,
  setColor: (color: IOption | null) => void,
  colors: IOption[]
}

const margin = 20;
const sizes = [36, 25, 20, 15]; // [xlarge, large, medium, small]
const opacities = [1, 1, 0.75, 0.5];

const ColourBubbles = ({color, setColor, colors}: IColourBubbles) => {
  const [bubbles, setBubbles] = useState<IOption[]>([])
  const [updateIndex, setUpdateIndex] = useState(false)
  
  const updateBubblesOrder = (color: IOption, bubbles: IOption[]) => {
    let newBubbles: IOption[] = [...bubbles]

    const middle = Math.round(bubbles.length / 2) - 1
    
      // lefter than middle (shift to the right)
    if (newBubbles.indexOf(color) < middle) {
      while (newBubbles.indexOf(color) !== middle) {
        const temp = newBubbles.pop()
        if (temp) newBubbles.unshift(temp)
      }
    }
    // righter than middle (shift to the left)
    else if (newBubbles.indexOf(color) > middle) {
      while (newBubbles.indexOf(color) !== middle) {
        const temp = newBubbles.shift()
        if (temp) newBubbles.push(temp)
      }
    }

    setBubbles(newBubbles)
  }

  // initialise bubbles in the correct order
  useEffect(() => {
    if (bubbles.length === 0 && color) {
      if (colors.length >= 7) updateBubblesOrder(color, colors)
      else setBubbles(colors)
    }
  }, [color, colors, bubbles])


  // update index of selected color
  useEffect(() => {
    // if less than 7 colours that just don't loop
    if (bubbles.length < 7) {
      setTimeout(() => {
        setUpdateIndex(false)
      }, 300);
      return
    } 

    if (updateIndex && color) {
      // wait until the end of animation
      setTimeout(() => {
        setUpdateIndex(false)

        updateBubblesOrder(color, bubbles)
      }, 300)
    }
  }, [updateIndex, color, bubbles])

  
  const bubbleClick = (c: IOption) => {
    if (!updateIndex && color && color !== c) {
      setColor(c)
      setUpdateIndex(true)
    }
  }

  const getPosition = (fromSelected: number) => {
    if (fromSelected === 0) return 0
    
    const positiveNumber = fromSelected >= 0;
    
    let position = 0, arrayPosition = Math.abs(fromSelected);

    for (let i = 0; i < arrayPosition && i < sizes.length; i++) {
      position += sizes[i] + margin;
    }

    return positiveNumber ? position : -position;
  }

  const renderBubbles = () => {
    if (!color || bubbles.length === 0) return

    return bubbles.map((c, index) => {
      const selectedIndex = bubbles.indexOf(color)

      let fromSelected = index - selectedIndex // how far element from selected

      let size
      if (Math.abs(fromSelected) < sizes.length) {
        size = sizes[Math.abs(fromSelected)]
      }
      else {
        size = 0
      }

      let opacity
      if (Math.abs(fromSelected) < opacities.length) {
        opacity = opacities[Math.abs(fromSelected)]
      }
      else {
        opacity = 0
      }
    
      const position = getPosition(fromSelected)

      return (
        <div key={c.value} className={styles.bubbleHolder}>
          <ColourBubble
            color={c.label}
            size={size}
            opacity={opacity}
            position={position}
            active={c === color}
            onClick={() => bubbleClick(c)}
          />
        </div>
      )
    })
  }
  
  return (    
    <div className={styles.bubbles}>
      { renderBubbles() }
    </div>
  )
};

export default ColourBubbles;